export type AppTheme =
  | "terminal"
  | "warm-cockpit"
  | "relaxed-grey"
  | "vibe"
  | "deep-navy"
  | "chart-paper"
  | "signal-deck"
  | "orbit-3d";

export type ThemeStyle = "mono-sharp" | "sans-rounded" | "sans-rounded-xl" | "serif-warm" | "neo-3d";

export const THEMES: {
  id: AppTheme;
  label: string;
  description: string;
  style: ThemeStyle;
  mode: "dark" | "light";
  primary: string;
  bg: string;
  accent: string;
}[] = [
  {
    id: "terminal",
    label: "Dark Terminal",
    description: "Radar green · monospace · sharp",
    style: "mono-sharp",
    mode: "dark",
    primary: "#22c55e",
    bg: "#0d1117",
    accent: "#16a34a",
  },
  {
    id: "warm-cockpit",
    label: "Warm Cockpit",
    description: "Amber gold · dark charcoal · rounded",
    style: "sans-rounded",
    mode: "dark",
    primary: "#f59e0b",
    bg: "#1c1914",
    accent: "#d97706",
  },
  {
    id: "relaxed-grey",
    label: "Space Grey",
    description: "Steel grey · sky blue · refined",
    style: "sans-rounded",
    mode: "dark",
    primary: "#4a90e2",
    bg: "#1e2124",
    accent: "#3a7bd5",
  },
  {
    id: "vibe",
    label: "VIBE ✦",
    description: "Hot pink · neon · for the vibes",
    style: "sans-rounded-xl",
    mode: "dark",
    primary: "#f472b6",
    bg: "#120820",
    accent: "#a855f7",
  },
  {
    id: "deep-navy",
    label: "Deep Navy",
    description: "Midnight blue · sky accent · smooth",
    style: "sans-rounded",
    mode: "dark",
    primary: "#4a90e2",
    bg: "#0b132b",
    accent: "#3a7bd5",
  },
  {
    id: "chart-paper",
    label: "Chart Paper",
    description: "Warm cream · Lora serif · wood sidebar",
    style: "serif-warm",
    mode: "light",
    primary: "#a63b2d",
    bg: "#f4ecdf",
    accent: "#6b5a3e",
  },
  {
    id: "signal-deck",
    label: "Signal Deck",
    description: "HUD orange · JetBrains · razor corners",
    style: "mono-sharp",
    mode: "dark",
    primary: "#f97316",
    bg: "#0f1419",
    accent: "#22d3ee",
  },
  {
    id: "orbit-3d",
    label: "Orbit 3D",
    description: "Violet depth · stacked shadows · bevel glow",
    style: "neo-3d",
    mode: "dark",
    primary: "#a78bfa",
    bg: "#0c0a14",
    accent: "#38bdf8",
  },
];

export const VALID_THEMES: AppTheme[] = [
  "terminal",
  "warm-cockpit",
  "relaxed-grey",
  "vibe",
  "deep-navy",
  "chart-paper",
  "signal-deck",
  "orbit-3d",
];

export function migrateTheme(stored: string | null): AppTheme {
  if (!stored) return "deep-navy";
  if ((VALID_THEMES as string[]).includes(stored)) return stored as AppTheme;
  if (stored === "cockpit" || stored === "blue" || stored === "amber") return "warm-cockpit";
  if (stored === "sectional" || stored === "light") return "deep-navy";
  if (stored === "green") return "terminal";
  return "deep-navy";
}
